import { toSaIsoDate, toUtcIsoDate } from '@packages/format';
const MS_PER_DAY = 24 * 60 * 60 * 1000;
/**
 * Whole days the invoice is past its effective due date as at `asOf`: positive
 * once overdue, 0 on the due date, negative while still to come. The effective
 * due date is the due date, else the invoice date, matching the
 * `effectiveDueDate` column.
 *
 * Invoice dates are stored as UTC midnight of their calendar day, so the due
 * day is read in UTC; "today" is read on the South African calendar, so an
 * invoice turns overdue at SAST midnight rather than two hours later.
 */
export function invoiceDaysPastDue(invoice, asOf) {
    const dueDay = toUtcIsoDate(new Date(invoice.dueDate ?? invoice.date));
    return Math.round((Date.parse(toSaIsoDate(asOf)) - Date.parse(dueDay)) / MS_PER_DAY);
}
